var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/services/bluetooth/lib/utils/bluetooth.constants.js
var require_bluetooth_constants = __commonJS({
  "server/services/bluetooth/lib/utils/bluetooth.constants.js"(exports, module) {
    var VARIABLES = {
      PRESENCE_STATUS: "BLUETOOTH_PRESENCE_STATUS",
      PRESENCE_FREQUENCY: "BLUETOOTH_PRESENCE_FREQUENCY"
    };
    var PRESENCE_STATUS = {
      ENABLED: "enabled",
      DISABLED: "disabled"
    };
    var TIMERS = {
      SCAN: 5e3,
      CONNECT: 5e3,
      DISCOVER: 5e3,
      READ: 2e3,
      WRITE: 2e3,
      PRESENCE: 6e4
    };
    var PARAMS = {
      CONNECTABLE: "connectable",
      LOADED: "loaded",
      MANUFACTURER: "manufacturer"
    };
    module.exports = { VARIABLES, PRESENCE_STATUS, TIMERS, PARAMS };
  }
});
const __cjsModule = require_bluetooth_constants();
export default __cjsModule;
export const VARIABLES = __cjsModule.VARIABLES;
export const PRESENCE_STATUS = __cjsModule.PRESENCE_STATUS;
export const TIMERS = __cjsModule.TIMERS;
export const PARAMS = __cjsModule.PARAMS;
